/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { NetSuiteConfig } from "./NetSuiteConfig";
import {
  NetSuiteConfigFromJSON,
  NetSuiteConfigFromJSONTyped,
  NetSuiteConfigToJSON,
  NetSuiteConfigToJSONTyped,
} from "./NetSuiteConfig";
import type { MaskedCompanyIntegration } from "./MaskedCompanyIntegration";
import {
  MaskedCompanyIntegrationFromJSON,
  MaskedCompanyIntegrationFromJSONTyped,
  MaskedCompanyIntegrationToJSON,
  MaskedCompanyIntegrationToJSONTyped,
} from "./MaskedCompanyIntegration";

/**
 *
 * @export
 * @interface IntegrationNetSuite
 */
export interface IntegrationNetSuite {
  /**
   *
   * @type {MaskedCompanyIntegration}
   * @memberof IntegrationNetSuite
   */
  integration: MaskedCompanyIntegration;
  /**
   *
   * @type {NetSuiteConfig}
   * @memberof IntegrationNetSuite
   */
  config: NetSuiteConfig;
}

/**
 * Check if a given object implements the IntegrationNetSuite interface.
 */
export function instanceOfIntegrationNetSuite(
  value: object,
): value is IntegrationNetSuite {
  if (!("integration" in value) || value["integration"] === undefined)
    return false;
  if (!("config" in value) || value["config"] === undefined) return false;
  return true;
}

export function IntegrationNetSuiteFromJSON(json: any): IntegrationNetSuite {
  return IntegrationNetSuiteFromJSONTyped(json, false);
}

export function IntegrationNetSuiteFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IntegrationNetSuite {
  if (json == null) {
    return json;
  }
  return {
    integration: MaskedCompanyIntegrationFromJSON(json["integration"]),
    config: NetSuiteConfigFromJSON(json["config"]),
  };
}

export function IntegrationNetSuiteToJSON(json: any): IntegrationNetSuite {
  return IntegrationNetSuiteToJSONTyped(json, false);
}

export function IntegrationNetSuiteToJSONTyped(
  value?: IntegrationNetSuite | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    integration: MaskedCompanyIntegrationToJSON(value["integration"]),
    config: NetSuiteConfigToJSON(value["config"]),
  };
}
